const state = {
  timer: {},
  timerObject: {}
}

const mutations = {
  SET_TIMER: (state, obj) => {
    state.timer[obj.name] = obj.timer
  },
  SET_TIMER_OBJECT: (state, obj) => {
    state.timerObject[obj.name] = obj
  },
  CLEAR_TIMER: (state, name) => {
    const timer = state.timer[name]
    clearTimeout(timer)
    delete state.timer[name]
  }
}

const actions = {
  /**
   * @param {String}
   * @param {Object} {name: 计时器名字, fn: 计时结束回调, time: 计时时间}
   */
  init({ dispatch, commit, state }, obj) {
    return new Promise((resolve, reject) => {
      commit('SET_TIMER_OBJECT', { ...obj })
      const timer = setTimeout(() => {
        commit('CLEAR_TIMER', obj.name)
        obj.fn()
        resolve()
        dispatch('init', obj)
      }, obj.time)
      commit('SET_TIMER', { name: obj.name, timer })
    })
  },

  clear({ commit }, name) {
    commit('CLEAR_TIMER', name)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
